class RealSlider {
    constructor() {
        this.realisations = document.querySelector(".realisations");
        if (!this.realisations) {
            return;
        }
        this.prevArrow = this.realisations.querySelector('.prev-btn');
        this.nextArrow = this.realisations.querySelector('.next-btn');
        const realSlider = new Swiper(".real-swiper", {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,

            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 50,
                },

                990: {
                    slidesPerView: 2,
                    spaceBetween: 80,
                },

                2000: {
                    slidesPerView: 3,
                    spaceBetween: 80,
                }
            },

            navigation: {
                nextEl: this.nextArrow,
                prevEl: this.prevArrow,
                clickable: true,
            }
        });
    }
}